import DynamicView from './DynamicView'

export default DynamicView